import { render } from "./HelloWorld.vue?vue&type=template&id=ead786b0&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=ead786b0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ead786b0"

export default script